import TradeArrow from '../../src/legacy/TradeArrow.tsx';
export default TradeArrow;
